import {KeyCloackUserDTO} from "./KeyCloackUserDTO";
import {OrganisationAccountDTO} from "./OrganisationAccountDTO";

export class AuthInfoDTO {
    public userId?: string;
    public email?: string;
    public authorizationList?: string[];
    public fullName?: string;
    public firstName?: string;
    public lastName: string
    public accountInfo?: KeyCloackUserDTO;
    public organisationAccount: OrganisationAccountDTO;
    public domain: string;
    public subdomanin: string;
    public isSelectedOrganisationAccount: OrganisationAccountDTO;

    constructor() {
    }

    bindData(obj: any): void {
        if (obj == null) {
            return;
        }
        this.userId = obj.userId;
        this.email = obj.email;
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.authorizationList = obj.authorizationList;
        this.fullName = obj.firstName + " " + obj.lastName;
        if (obj.accountInfo) {
            this.accountInfo = new KeyCloackUserDTO();
            this.accountInfo.bindData(obj.accountInfo);
        }
        if (obj.domain) {
            this.domain = obj.domain;
        }
        if (obj.subdomanin) {
            this.subdomanin = obj.subdomanin;
        }

        if (obj.organisationAccount) {
            this.organisationAccount= new OrganisationAccountDTO();
            this.organisationAccount.bindData(obj.organisationAccount);
        }

    }
}
